

































































































import {
    Component,
    Vue
} from 'vue-property-decorator';
import axios from '../common/api';
import DeliverPicker from '../components/DeliverPicker.vue'

import {
    ORDER_STATUS, ORDER_STATUS_DESC, ORDER_TYPE_MAP
} from '../common/const';

import uploader from '../common/FileUploader'
import { day8 } from '../common/utils';
@Component({
    components: {
        DeliverPicker
    },
})
export default class Index extends Vue {

    ORDER_STATUS = ORDER_STATUS
    ORDER_STATUS_DESC = ORDER_STATUS_DESC
    ORDER_TYPE_MAP = ORDER_TYPE_MAP
    order: any = {}
    orderlog:any[] = []
    file:File = null
    day8 = day8
    comment:string = ''

    newDate:any = ''

    files:any[] =[]

    get workingDays(){
        if(this.order.id){
            return Number(this.order.group_period.split('-')[0])
        }
        return 0
    }

    get displayStatus(){
        return Object.keys(ORDER_STATUS).filter(key=>{
            let v = Number(key)
            if(v == 550 && this.order.spec_type ==1){
                return false
            }
            return v % 10 === 0
        }).map(key=>{
            return {
                value: Number(key),
                label: ORDER_STATUS[key]
            }
        })
    }

    get product(){
        return this.$store.state.products.find(p=>p.id === this.order.specid) || {}
    }

    created() {
        let id = this.$route.params.id
        axios.get('/order',{params:{id}}).then(res => {
            this.order = res.data
            console.log(this.product)
            if(this.order.file_url){
                this.files = this.order.file_url.split('|').filter(f=>f).map(f=>decodeURIComponent(f))
            }
        })
        axios.get('/orderlog',{params:{id}}).then(res=>{
            res.data.reverse()
            this.orderlog = res.data
        })
    }
    fileChange(e){
        this.file = e.target.files[0]
        uploader.upload(this.file).then(res=>{
            axios.post('/updatefile',{id: this.order.id, file_url:res.url}).then(r=>{
                location.reload()
            })
        })
    }

    saveComment(){
        if(this.comment){
            axios.post('/updatecomment',{id:this.order.id,comment:this.comment}).then(res=>{
                location.reload()
            })
        }
    }

    dateChange(val){
        this.newDate = val
    }
    saveNewDate(){
        if(this.newDate){
            this.$loading({})
            axios.post('/updatedeliver', {
                id: this.order.id,
                deliver_date: day8(this.newDate).format('YYYY-MM-DD'),
                status: 400
            }).then(res => {
                this.$message.success('修改成功')
                setTimeout(()=>{
                    location.reload()
                },600)
            })
        }
    }
   
}
